import { useEffect } from 'react';

import { useHistory } from '@treams/treams-routes';

export default function DefaultVersionSwitch() {
	const history = useHistory();

	useEffect(() => {
		if (
			history.location.pathname.startsWith('/v2/authentication') ||
			history.location.pathname.startsWith('/authentication')
		) {
			return;
		}

		const version = 'v2';

		if (!history.location.pathname.startsWith('/v2') && version === 'v2') {
			history.replace(history.location.pathname, true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
}
